// src/pages/ResetPassword.tsx
import { useState } from "react";
import { supabase } from "@/lib/supabase";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Link } from "react-router-dom";

export default function ResetPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleReset = async () => {
    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/confirm-password`,
    });

    if (error) {
      toast.error("Error al enviar el correo", { description: error.message });
    } else {
      toast.success("Correo enviado", {
        description:
          "Revisa tu bandeja para continuar con el cambio de contraseña",
      });
    }
    setLoading(false);
  };

  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-muted">
      <Card className="w-full max-w-md shadow">
        <CardHeader>
          <CardTitle className="text-center text-2xl">
            Recuperar contraseña
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Correo electrónico</Label>
            <Input
              id="email"
              type="email"
              placeholder=""
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <Button className="w-full" onClick={handleReset} disabled={loading}>
            {loading ? "Enviando..." : "Enviar correo"}
          </Button>
          <div className="mt-4 text-center text-sm space-y-1">
            <p>
              <Link to="/login" className="text-primary hover:underline">
                Iniciar sessión
              </Link>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
